import {
  isCalculated,
  isManualReadOnly,
  isManualRequired,
} from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.utils';

import { FieldType, NO_BOOLEAN_INPUT_PROPS } from 'constants/formGenerator';
import { getConditionalObject } from 'utils/data';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { CUSTOM_FIELDS_GROUP_KEY } from './ApplicationCustomFields.constants';
import {
  buildYupSchemaForDefinition,
  getDefinitionInputType,
  mapDefinitionToFieldType,
} from './ApplicationCustomFields.utils';

const buildFieldConfig = definition => {
  const fieldType = mapDefinitionToFieldType(definition);
  const inputType = getDefinitionInputType(definition);
  const isDisabled = isCalculated(definition) || isManualReadOnly(definition);
  const isRequired = isManualRequired(definition);
  const customSchema = isDisabled ? null : buildYupSchemaForDefinition(definition);

  return {
    type: fieldType,
    nameInModel: `customFields.${definition.id}`,
    noValidate: isDisabled,
    inputProps: {
      ...getConditionalObject(inputType, { type: inputType }),
      ...getConditionalObject(customSchema, { customSchema }),
      label: definition.name,
      placeholder: definition.name,
      required: isRequired,
      disabled: isDisabled,
      ...getConditionalObject(fieldType === FieldType.CHECKBOX, NO_BOOLEAN_INPUT_PROPS),
    },
  };
};

export const buildCustomFieldsEntityConfig = definitions => {
  const fields = definitions.map(buildFieldConfig);

  return fillConfigFieldsWithKeys({
    groups: [{ key: CUSTOM_FIELDS_GROUP_KEY, fields }],
  });
};
